// project imports
import getColors from 'utils/getColors';
import getShadow from 'utils/getShadow';

function getColor({ variant, theme }) {
  const colors = getColors(theme, variant);
  const { light } = colors;
  const shadows = getShadow(theme, `${variant}`);

  return {
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: light },
    '&.Mui-focused': {
      boxShadow: shadows,
      '& .MuiOutlinedInput-notchedOutline': { border: '1px solid', borderColor: light }
    }
  };
}

export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        // 🔧 Unifica padding (medium)
        input: { padding: '16.5px 13px' },
        // 🔧 Unifica padding (small)
        inputSizeSmall: { padding: '8.5px 13px' },
        inputMultiline: { padding: 0 },
        notchedOutline: { borderColor: theme.palette.grey[300] },
        root: {
          ...getColor({ variant: 'primary', theme }),
          '&.Mui-error': { ...getColor({ variant: 'error', theme }) }
        },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme })
      }
    },

    // 🔧 Alinea también los Select (no-nativos)
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '16.5px 13px',
          minHeight: 0 // evita alturas raras
        }
      }
    }
  };
}
